import { lazy, Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import { AuthProvider } from './lib/auth'
import { AccountProvider } from './lib/account'
import { BrandingProvider } from './lib/branding'
import AuthGate from './app/AuthGate'
import PageLoader from './app/PageLoader'

// ─── Public routes (no auth required) ──────────────────────
const Terms = lazy(() => import('./pages/Terms'))
const Privacy = lazy(() => import('./pages/Privacy'))
const Help = lazy(() => import('./pages/Help'))
const QuoteView = lazy(() => import('./pages/QuoteView'))
const AmendmentView = lazy(() => import('./pages/AmendmentView'))
const ClientPortal = lazy(() => import('./pages/ClientPortal'))
const BookingPage = lazy(() => import('./pages/BookingPage'))

export default function App() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        {/* Public pages — no auth required */}
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/help" element={<Help />} />
        <Route path="/quote/:id" element={<QuoteView />} />
        <Route path="/amendment/:id" element={<AmendmentView />} />
        <Route path="/portal/:token" element={<ClientPortal />} />
        <Route path="/book/:slug" element={<BookingPage />} />
        {/* Everything else goes through auth */}
        <Route path="*" element={
          <AccountProvider>
            <BrandingProvider>
              <AuthProvider>
                <AuthGate />
              </AuthProvider>
            </BrandingProvider>
          </AccountProvider>
        } />
      </Routes>
    </Suspense>
  )
}
